import { MySvgIcon, MySvgIconProps } from './MySvgIcon'

type IconPieChartProps = MySvgIconProps & {
  className?: string
  focusable?: boolean
  title?: string
  ariaHidden?:boolean
}

export const IconPieChart = ({ ...props }: IconPieChartProps) => (
  <MySvgIcon
    width="21px"
    height="21px"
    viewBox="0 0 24 24"
    version="1.1"
    title="Pie Chart Icon"
    ariaHidden
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <g transform="translate(0.333333, 0.333333)">
        <path d="M21.0224999,13.1248579 L10.2084755,13.1248579 L10.2084755,2.3108334 C10.2084755,1.87561095 9.82611773,1.51831839 9.39545259,1.57893052 C3.96861608,2.3454689 -0.180352642,7.08324118 0.00604105375,12.7634637 C0.191523289,18.4158868 4.91790231,23.14181 10.5698696,23.3272923 C16.2500922,23.513686 20.9878644,19.3647173 21.7544028,13.9378807 C21.8150149,13.5072156 21.4572667,13.1248579 21.0224999,13.1248579 Z M13.1616079,0.00164792568 C12.7459818,-0.0270630837 12.3959809,0.323393523 12.3959809,0.739931025 L12.3959809,10.9373524 L22.593858,10.9373524 C23.0103955,10.9373524 23.3603964,10.5868958 23.3321411,10.1717255 C22.9561636,4.72757122 18.6057621,0.377169699 13.1616079,0.00164792568 Z" />
      </g>
    </g>
  </MySvgIcon>
)
